<template>
  <div>
    <div class="bigbox">
      <div class="top clearfix">
        <span class="icons"></span>
        <span class="topstatus">运行状态</span>
        <span class="selete">
          <select class="seleteware" v-model="seletevalue">
            <option value="自动">自动</option>
            <option value="手动">手动</option>
          </select>
        </span>
      </div>
      <div class="tab">
        <div
          class="tabbg clearfix"
          v-for="(item,index) in arr"
          :key="index"
          :class="[{'pitch':arrindex==item}]"
          @click="indexchange(item)"
        >{{item}}</div>
      </div>
      <div class="details">
        <div class="detailsdata clearfix" v-for="(item,index) in stateData" :key="index">
          <i class="icons iconsom"></i>
          <span>{{item.name}}:</span>
          <span
            v-if="item.details"
            style="fontSize:18px;fontWeight:500"
          >{{item.details}}({{item.value}})</span>
          <span v-else>{{item.value}}</span>
          <span></span>
        </div>
      </div>
      <div class="bottom">
        <div class="bottombg" v-for="(item,index) in bgData" :key="index">
          <div class="part">
            <div class="figure" v-if="index==0">{{item.value}}<i class="fonts">V</i> </div>
            <div class="figure" v-if="index==1">{{item.value}}<i class="fonts">R</i> </div>
              <div class="figure" v-if="index==2">{{item.value}}<i class="fonts">℃</i></div>
                <div class="figure" v-if="index==3">{{item.value}}<i class="fonts">R/s</i></div>
            <div class="character">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts41",
  props: {
    stateData: {
      type: Array,
    },
    bgData: {
      type: Array,
    }
  },
  data() {
    let arr = ["故障", "运行", "停机"];
    return {
      arr: arr,
      arrindex: arr[1],
      seletevalue: "自动"
    };
  },
  mounted() {},
  methods: {
    indexchange(item) {
      this.arrindex = item;
      this.$emit("itemchange", item);
    }
  }
};
</script>
<style scoped>
.bigbox {
  width: 300px;
  height: 390px;
  position: relative;
  margin: 0 auto;
}
.top {
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  margin-top: 20px;
}
.icons {
  width: 12px;
  height: 12px;
  margin-top: 13px;
  margin-left: 10px;
  display: inline-block;
  background: url("../../assets/img/echarts13-1.png") no-repeat;
  background-size: 12px 12px;
}
.topstatus {
  width: 75px;
  line-height: 40px;
  display: inline-block;
  font-size: 16px;
  text-align: left;
  margin-left: 5px;
  color: #89d8e9;
}
.selete {
  width: 38px;
  height: 16px;
  margin-top: 5px;
  line-height: 16px;
}
.seleteware {
  color: #fff;
  background-color: #74D4A9;
  padding: 5px 8px;
  font-size: 12px;
}
.tab {
  width: 100%;
  height: 100px;
  display: flex;
  padding:15px 0;
}
.tabbig {
  width: 33%;
  height: 100%;
  line-height: 100px;
}
.tabbg {
  width: 86px;
  height: 86px;
  background: url("../../assets/img/echarts41-1.png") no-repeat;
  margin: 0 auto;
  text-align: center;
  line-height: 86px;
  color: #547793;
  font-weight: 500;
}
.pitch {
  font-size: 18px;
  color: #fff;
  font-weight: 700;
  transform: scale(1.2);
}
.details {
  width: 100%;
  height: 120px;
}
.detailsdata {
  width: 100%;
  line-height: 40px;
}
.iconsom {
  background-size: 12px 12px;
}
.detailsdata span {
  font-size: 16px;
}
.bottom {
  width: 100%;
  height: 130px;
  display: flex;
  flex-wrap: wrap;
}
.bottombg {
  width: 50%;
  height: 65px;
}
.part {
  width: 119px;
  height: 56px;
  background: url("../../assets/img/echarts41-2.png") no-repeat;
  background-size: 100% 100%;
  margin-left: 15px;
}
.figure {
  width: 100%;
  height: 40px;
  font-size: 26px;
  text-align: center;
  line-height: 50px;
  color: #07694C;
}
.character {
  width: 100%;
  height: 14px;
  font-size: 12px;
  text-align: center;
  line-height: 12px;
}
.fonts {
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts13.vue